import _startCase from "lodash/startCase";
import { useTranslation } from "react-i18next";
import { Checkbox, Dropdown, Grid, GridColumn } from "semantic-ui-react";

import { DealersAndLocationsDropdown, ExportDataButton, NavPortal, ResetFiltersButton, SearchFilter, useCan } from "components";
import { usePermanentRealTimeUser } from "hooks";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { LeadTypeFilter, LeadsExportModal } from "modules/LeadsDashboard/components";
import { useExportModal, useSystemTagOptions } from "modules/LeadsDashboard/hooks";
import { exportLeadsNotSnoozed, useLeadsNotSnoozedFilters, useNotSnoozedFilterHandlers } from "modules/LeadsDashboard/Leads/NotSnoozedLeads/hooks";

export const NotSnoozedLeadsFilters = () => {
  const { t } = useTranslation();

  const { user } = usePermanentRealTimeUser();
  const canExportLeads = useCan(ACL_ACTIVITIES.Export, ACL_RESOURCES.LeadsNotSnoozed);
  const { handleCloseExportModal, handleOpenExportModal, showExportModal } = useExportModal();
  const filters = useLeadsNotSnoozedFilters();
  const { handleTagsChange, handleResetFilters, handleSearchChange, handleInterventionsChange, handleDealerLocationChange, handleCustomerApprovedChange } =
    useNotSnoozedFilterHandlers();
  const { systemTagOptions } = useSystemTagOptions();

  const { search_term, dealer_ids, location_ids, tags, customer_approved, interventions } = filters;

  return (
    <>
      <NavPortal>
        <SearchFilter value={search_term} handleSearchChange={handleSearchChange} />
      </NavPortal>

      <div className="toolbar-container">
        <Grid columns={16} className="toolbar-grid">
          <GridColumn width={3} className="no-left-gutter right-gutter">
            <LeadTypeFilter />
          </GridColumn>
          <GridColumn width={5} className="left-gutter right-gutter">
            <DealersAndLocationsDropdown
              values={{ dealerIds: dealer_ids, locationIds: location_ids }}
              handleOnChange={({ dealerIds, locationIds }) => handleDealerLocationChange({ dealerIds, locationIds })}
              allowSelectAllDealers={false}
            />
          </GridColumn>
          <GridColumn width={3} className="left-gutter right-gutter">
            <Dropdown
              fluid
              selection
              clearable
              name="tag"
              multiple
              value={tags || []}
              selectOnBlur={false}
              options={systemTagOptions}
              placeholder={t("v8_tags", "Tags")}
              onChange={(_, { value }) => handleTagsChange(value as number[])}
            />
          </GridColumn>

          <GridColumn width={5} className="no-left-gutter no-right-gutter flex-align-justify-center">
            <div className="filters-checkboxes-container">
              <div className="filters-checkbox-container">
                <Checkbox toggle name="customer_approved" onChange={handleCustomerApprovedChange} checked={customer_approved} />
                <span className="no-wrap-text"> {_startCase(t("v8_customer_approved", "Customer approved"))}</span>
              </div>
              <div className="filters-checkbox-container">
                <Checkbox toggle name="intervention" onChange={handleInterventionsChange} checked={interventions} />
                <span className="no-wrap-text"> {t("v8_interventions", "Interventions")}</span>
              </div>
            </div>
          </GridColumn>
        </Grid>

        <div className="toolbar-reset-export-buttons-container">
          <ResetFiltersButton handleReset={handleResetFilters} />
          {user?.csv_download && canExportLeads && <ExportDataButton handleOnClick={handleOpenExportModal} disabled={!dealer_ids.length && !location_ids.length} />}
        </div>
      </div>

      <LeadsExportModal open={showExportModal} onClose={handleCloseExportModal} onExport={() => exportLeadsNotSnoozed(filters)} />
    </>
  );
};
